import { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import i18n, { loadTranslations } from 'i18n';
import { accountIdSelector } from 'store/user/selectors';
import axios from 'utils/axios';
import { ITINERARIES_ITEM_TYPE_TO_ROUTE_SEGMENT_MAP } from 'utils/itineraries/functions';
import { IProposal } from 'utils/itineraryDetails/types';

import { getLandingForViewMode } from '../../../PropertyPortal/functions';

export interface IPDFPreviewDataWrapperProps {
  itemData: IProposal;
  itemType: string;
  itemId: string;
  prepareItemDataFn: (p: IProposal) => IProposal;
}

export function usePDFPreviewDataWrapper({
  itemData,
  itemType,
  itemId,
  prepareItemDataFn,
}: IPDFPreviewDataWrapperProps) {
  const accountId = useSelector(accountIdSelector);
  const [data, setData] = useState(itemData);

  useEffect(() => {
    if (itemId === undefined) {
      prepareDocumentBody(itemData.title);

      return;
    }

    let url = `/${ITINERARIES_ITEM_TYPE_TO_ROUTE_SEGMENT_MAP[itemType]}/${itemId}`;

    if (accountId) {
      url = `/acc/${accountId}` + url;
    }

    axios
      .get(url, {
        params: {
          client_facing: true,
        },
      })
      .then(async ({ data }) => {
        await loadTranslations(i18n, data?.settings?.language);
        return data;
      })
      .then((data) => {
        setData(
          prepareItemDataFn(
            getLandingForViewMode(data, {
              alwaysHideImageBlocks: true,
            }),
          ),
        );

        prepareDocumentBody(data.title);
      });
  }, []);

  return { data };
}

function prepareDocumentBody(title: string) {
  const root = document.getElementById('root');
  if (root) root.style.display = 'none';

  document.body.style.height = 'unset';

  if (title) document.title = title;
}
